import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { masterServices } from 'src/app/module/master/services/ems-services.service';
import { ordersService } from '../../services/orders.service';
import { MessageService } from 'primeng/api';
import { SharedService } from 'src/app/shared/shared.service';
import { RegisterService } from 'src/app/auth/container/registration-module/register.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-add-component',
  templateUrl: './add-component.component.html',
  styleUrls: ['./add-component.component.css']
})
export class AddComponentComponent {
truckDetails: any;
tyreList: any;
batteryList: any;
componantList: any;
serialNumber: any;
selectedComponent: any;
componentType: any;
associationDate:any;
associationStatus:any
associationkm:any
associationType: any;
maxDate: Date = new Date();
allCatagory: any;
sendCatagoryId: any;

selectedTyre: any[] = [];
pollutionVendorList: any;
selectedFiles:FileList  | null = null;
currentFile?: File;
progress = 0;
@ViewChild('uploadVendorInput') uploadVendorInput!: ElementRef;
@ViewChild('uploadInsuranceInput') uploadInsuranceInput!: ElementRef;
@ViewChild('uploadPollutionInput') uploadPollutionInput!: ElementRef;
pollutionUploadUrl: string | null = null;
vendorUploadUrl: string | null = null;
insuranceUploadUrl: string | null = null;

pollutionNumber:any
pollutionValidityFrom:any
pollutionValidityTill:any;

  constructor(
    public dialogRef: DynamicDialogRef,
        private datePipe: DatePipe,
        public data: DynamicDialogConfig,
        private masterServices: masterServices,
        private ordersService: ordersService,
        private messageService: MessageService,
        public sharedService: SharedService,
        private registerService: RegisterService,
        private cd: ChangeDetectorRef
  ){
    console.log("data",data)

    this.truckDetails = data?.data?.data
    console.log(this.truckDetails)
    this.allCatagory = JSON.parse(localStorage.getItem('categoryMap')!);
    this.sendCatagoryId = this.setId();

  }


  onTypeChange(type:any){
    console.log(type)
    this.componentType = type
    if(this.componentType == 'Tyre' || this.componentType == 'Battery'){
      const postData = [
        {
          key: 'COMPONENT_TYPE_IN',
          value: this.componentType,
        },
        {
          key: 'STATUS_IN',
          value: 'new,idle',
        }
      ];
      this.masterServices.getComponentInfo(postData, 0, 1000, 'id', 'DESC').subscribe((data: any) => {
              this.componantList = data?.responseObject?.content;
            this.serialNumber = ''
            if(this.componentType == 'tyre'){
              this.tyreList = data?.responseObject?.content;
            }else if(this.componentType == 'battery'){
              this.batteryList = data?.responseObject?.content;
            }
          },(err) => {
            this.componantList = []
            this.batteryList = [];
            this.tyreList = [];
          },
        );
    }
    if(this.componentType == 'Insurance'){
      // const postData = [];
      this.masterServices.getInsuranceInfo([], 0, 1000, 'id', 'DESC').subscribe((data: any) => {
              this.componantList = data?.responseObject?.content;
          },(err) => {
            this.componantList = []
            this.batteryList = [];
            this.tyreList = [];
          },
        );
    }
     if(this.componentType == 'PUC'){
      this.getQuickCodeListByCategoryId(this.sendCatagoryId.toString());
      }
     if(this.componentType == 'Dealer'){
      // const postData = [];
      this.masterServices.getVendorInfo([], 0, 1000, 'id', 'DESC').subscribe((data: any) => {
              this.componantList = data?.responseObject?.content;
          },(err) => {
            this.componantList = []
            this.batteryList = [];
            this.tyreList = [];
          },
        );
    }

  }
setId(): (number | undefined)[] {
  const keys = ['pollutionVendor'];
  return keys.map((key) => this.allCatagory?.[key]?.id);
}
getQuickCodeListByCategoryId(ids: any) {
    this.registerService
      .getQuickCodeListByCategoryId(ids)
      .subscribe((data: any) => {
        this.componantList = data?.responseObject?.pollutionVendor;
      },(err) => {
            this.componantList = []});
  }

  onserialChange(event:any){
    console.log(event)
    const componant = this.componantList.find((s: any) => s.id === event);
    console.log(componant,'componantcomponant')
    this.selectedComponent = componant
    if(this.componentType == 'Dealer'){
      this.pollutionNumber = this.selectedComponent?.vendorName
    }
  }
  onChangecomponentType(associationType:any){
    console.log(associationType)
      this.associationType = associationType
  }
  addComponent(){
  
    let associatedTyres = this.truckDetails?.associatedTyres || 0;
    let associatedTrailerTyres = this.truckDetails?.associatedTrailerTyres || 0;
    let associatedBatteries = this.truckDetails?.associatedBatteries || 0;

    if (this.selectedComponent?.componentType === "Tyre" 
      && this.associationType === "TRUCK"
      ) {
        if ((this.truckDetails?.tyreCapacity ?? 0) <= associatedTyres) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Limit reached',
            detail: `Maximum ${this.truckDetails?.tyreCapacity} Truck tyres allowed`
          });
          return;
        }
        associatedTyres = associatedTyres + 1;
        // return ;
    }
    if (this.selectedComponent?.componentType === "Tyre" &&
        this.associationType === "TRAILER") {
      if((this.truckDetails?.trailerTyreCapacity ?? 0) <= associatedTrailerTyres){
          this.messageService.add({
            severity: 'warn',
            summary: 'Limit reached',
            detail: `Maximum ${this.truckDetails?.trailerTyreCapacity} Trailer tyres allowed`
          });
          return
        }
        associatedTrailerTyres = associatedTrailerTyres + 1;
      //   return false;
    }
    if (this.selectedComponent?.componentType === "Battery") {
      if((this.truckDetails?.batteryCapacity?? 0) <= associatedBatteries){
        this.messageService.add({
          severity: 'warn',
          summary: 'Limit reached',
          detail: `Maximum ${this.truckDetails?.associatedBatteries} Battery allowed`
        });
        return
      }
      associatedBatteries = associatedBatteries + 1;
      //   return false;
    } 

    // const parseDate = (date: any) => {
    //     if (!date) return null;

    //     if (date instanceof Date) return date;

    //     const [datePart] = date.split(' ');
    //     const [day, month, year] = datePart.split('-');
    //     return new Date(`${year}-${month}-${day}`);
    //   };
      // const insuranceTill = parseDate(this.insuranceValidityTill);
      // const insuranceFrom = parseDate(this.pollutionValidityFrom); // for insurance case

      // const pucFrom = parseDate(this.pollutionValidityFrom);
      // const pucTill = parseDate(this.pollutionValidityTill);

      // const dealerFrom = parseDate(this.pollutionValidityFrom);
      // const dealerTill = parseDate(this.pollutionValidityTill);

      let payload: any;
      if(this.componentType == 'Tyre' || this.componentType == 'Battery'){
      payload = {
        id: this.truckDetails?.id,
        associatedTyres: associatedTyres,
        associatedTrailerTyres: associatedTrailerTyres,
        associatedBatteries: associatedBatteries ,
        'initialKmTravelled':this.associationkm,
        commponentAssociation:
            [
              {
              associationType: this.associationType,
              componentType:this.selectedComponent?.componentType,
              "newComponentId": this.selectedComponent?.id,
              "newComponentStatus": 'InUse',
              newComponentVersion: this.selectedComponent?.version ?? null,
              newComponentFromDate:this.associationDate ? this.datePipe.transform(this.associationDate, 'dd-MM-yyyy HH:mm:ss Z')  : null,

            }
        ],
      }
      }
      const parseDate = (date: any) => {
        if (!date) return null;
        if (date instanceof Date) return date;
        const [datePart] = date.split(' ');
        const [day, month, year] = datePart.split('-');
        return new Date(`${year}-${month}-${day}`);
      };

    const pucTill = parseDate(this.truckDetails?.pucValidityTill);
    const insuranceTill = parseDate(this.truckDetails?.insuranceValidityTill);
    const vendorTill = parseDate(this.truckDetails?.pucValidityTill);
    const pollutionFrom = this.pollutionValidityFrom ? new Date(this.pollutionValidityFrom) : null;
      if(this.componentType == 'PUC'){
        if (pucTill && pollutionFrom && pollutionFrom <= pucTill) {
          this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'PUC already exists for these dates. Please update or remove it to continue.',
            });
          return;
        }
        console.log(this.truckDetails?.pucValidityTill)
        console.log(this.pollutionValidityFrom)
        payload = {
          id: this.truckDetails?.id,
          'initialKmTravelled':this.associationkm,
          newComponentFromDate:this.associationDate ? this.datePipe.transform(this.associationDate, 'dd-MM-yyyy HH:mm:ss Z')  : null,
          "isPuc": this.serialNumber ? true : 'false',
          'pucId':this.serialNumber,
          'puc':this.pollutionNumber,
          'pucValidityFrom':this.pollutionValidityFrom ? this.datePipe.transform(this?.pollutionValidityFrom, 'dd-MM-yyyy HH:mm:ss Z')  : null,
          'pucValidityTill':this.pollutionValidityTill ? this.datePipe.transform(this?.pollutionValidityTill, 'dd-MM-yyyy HH:mm:ss Z')  : null,
          'pucUrl':this.pollutionUploadUrl,
        }
        
      }
       if(this.componentType == 'Insurance'){
        if (insuranceTill && pollutionFrom && pollutionFrom <= insuranceTill) {
          this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Insurance already exists for these dates. Please update or remove it to continue.',
            });
          return;
        }
        payload = {
          id: this.truckDetails?.id,
          'initialKmTravelled':this.associationkm,
          newComponentFromDate:this.associationDate ? this.datePipe.transform(this.associationDate, 'dd-MM-yyyy HH:mm:ss Z')  : null,
          "isInsurance": this.serialNumber ? true : 'false',
          'insurerId':this.serialNumber,
          'insuranceNumber':this.pollutionNumber,
          'insuranceValidityFrom':this.pollutionValidityFrom ? this.datePipe.transform(this?.pollutionValidityFrom, 'dd-MM-yyyy HH:mm:ss Z')  : null,
          'insuranceValidityTill':this.pollutionValidityTill ? this.datePipe.transform(this?.pollutionValidityTill, 'dd-MM-yyyy HH:mm:ss Z')  : null,
          'insuranceUrl':this.pollutionUploadUrl,
        }
        
      }
        if(this.componentType == 'Dealer'){
          if (vendorTill && pollutionFrom && pollutionFrom <= vendorTill) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Dealer already exists for these dates. Please update or remove it to continue.',
              });
            return;
          }
        payload = {
          id: this.truckDetails?.id,
          'initialKmTravelled':this.associationkm,
          newComponentFromDate:this.associationDate ? this.datePipe.transform(this.associationDate, 'dd-MM-yyyy HH:mm:ss Z')  : null,
          // "isInsurance": this.serialNumber ? true : 'false',
          'vendorId':this.serialNumber,
          'vendorName':this.pollutionNumber,
          'vendorValidityFrom':this.pollutionValidityFrom ? this.datePipe.transform(this?.pollutionValidityFrom, 'dd-MM-yyyy HH:mm:ss Z')  : null,
          'vendorValidityTill':this.pollutionValidityTill ? this.datePipe.transform(this?.pollutionValidityTill, 'dd-MM-yyyy HH:mm:ss Z')  : null,
          'vendorUrl':this.pollutionUploadUrl,
        }
        
      }
      console.log(payload)
      this.ordersService.getBuild(payload).subscribe((data: any) => {
      if (data) {
        console.log(data)
        this.dialogRef.close(data);
        // this._route.navigate(['/orders']);
      }
    })
  }
close(){
  this.dialogRef.close('data');
}

onDateSelect(selectedDate: Date) {
  if (!selectedDate) return;
  const now = new Date();
  selectedDate.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );

  // this.associationDate = new Date(selectedDate);
}



    selectFile(event: any , type:any): void {
    this.selectedFiles = event.target.files;
    const fileType = type
      const file = event.target.files[0];

     const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/svg+xml'
    ];
    if (!allowedTypes.includes(file.type)) {
      // this.progress = 0;
      // this.uploadPath = null;
      // this.uploadFileName = null;
      // this.uploadVendorInput.nativeElement.value = null;
      // this.selectedFiles = undefined;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Uploaded file must be in excel format.',
      });
      return;
    }
    this.upload(fileType)
  }



   upload(type: any): void {
      // this.progress = 0;
      if (this.selectedFiles) {
          const file: File | null = this.selectedFiles.item(0);
        if (file) {
          this.currentFile = file;
  
          this.masterServices.upload(
            this.currentFile,
          ).subscribe({
            next: (event: any) => {
              if (event.type === HttpEventType.UploadProgress) {
                this.progress = Math.round((100 * event.loaded) / event.total);
                if (this.progress == 100) {
                  this.progress = 99;
                }
              } else if (event instanceof HttpResponse) {
                if(type == 'VENDOR'){
                  this.vendorUploadUrl = event.body.responseObject
                  this.cd.detectChanges();
                }else if(type == 'Pollution'){
                  this.pollutionUploadUrl = event.body.responseObject
                  this.cd.detectChanges();

                }else if(type = 'Insurance'){
                  this.insuranceUploadUrl = event.body.responseObject
                  this.cd.detectChanges();
                }
                // this.message = event.body.message;
                this.progress = 0;
                // this.uploadVendorInput.nativeElement.value = null;
                // this.messageService.add({
                //   severity: 'success',
                //   summary: 'Success',
                //   detail: 'Uploaded Successfully',
                // });
                // this.setInterval = setInterval(()=>{
                // this.intervalProgressList()
                setTimeout(() => {
                  // this.getListForCompleted();
                  // this.getlistForProgress()
                  // this.selectedType('none')
                  // this.selectUploadType = ''
                  // this.createPOForm.reset();
                }, 2000);
                // }
                // ,1000)
                // this.fileInfos = this.uploadService.getFiles();
              }
            },
            error: (err: any) => {
              // this.progress = 0;
              // this.uploadVendorInput.nativeElement.value = null;
              if (err.error && err.error.message) {
                const message = err.error.message;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: err.error.message,
                });
              } else {
                const message = 'Could not upload the file!';
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: message,
                });
              }
  
              // this.currentFile = undefined;
            },
          });
        }
  
        // this.selectedFiles = undefined;
      }
    }
   removeFile(type:any){
      if(type == 'VENDOR'){
        this.vendorUploadUrl = null
      }else if(type == 'Pollution'){
        this.pollutionUploadUrl = null
      }if(type == 'Insurance'){
        this.insuranceUploadUrl = null
      }
      if (this.uploadVendorInput) {
        this.uploadVendorInput.nativeElement.value = null;
      }
      if (this.uploadInsuranceInput) {
        this.uploadInsuranceInput.nativeElement.value = null;
      }
      if (this.uploadPollutionInput) {
        this.uploadPollutionInput.nativeElement.value = null;
      }
      
    }


}
